export default __webpack_public_path__ + "static/media/bg.d81a2203.png";